<template>
  <v-flex xs12 class="pt-4">
    <v-toolbar flat color="white">
      <v-toolbar-title>Сотрудники</v-toolbar-title>
      <v-layout row>
        <v-flex xs4 offset-xs8>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :expand=true
      :headers="headers"
      :items="employees"
      :search="search"
      rows-per-page-text="Отображать"
      class="elevation-10"
      sort-icon="fa-angle-up"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.employee_name }}</td>
        <td>
          <v-edit-dialog
            large
            lazy
            save-text="Сохранить"
            cancel-text="Отмена"
            @save="update(props.item.id, props.item.department_id)"
          > {{ props.item.department_name }}
            <template v-slot:input>
              <v-autocomplete
                :rules="[required]"
                :no-data-text="'Ничего не найдено.'"
                :items="departments"
                item-text="text"
                item-value="id"
                v-model="props.item.department_id"
                label="Отдел"
              >
              </v-autocomplete>
            </template>
          </v-edit-dialog>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Данных не обнаружено.
        </v-alert>
      </template>
      <template slot="pageText" slot-scope="props">
        Страница {{ props.pageStart }} из {{ props.pageStop }} всего {{ props.itemsLength }}
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        По запросу "{{ search }}" ничего не найдено.
      </v-alert>
    </v-data-table>
  </v-flex>
</template>

<script>
  export default {
    data() {
      return {
        search: '',
        dialog: false,
        headers: [
          {text: 'Ф.И.О', align: 'left', value: 'employee_name'},
          {text: 'Отдел', align: 'left', value: 'department_name'}
        ],
        departments: [],
        required: value => !!value || 'Название не заполнено.'
      }
    },
    methods: {
      async update (id, departmentId) {
        await this.$store.dispatch('updateEmployee', {id, departmentId})
      }
    },
    created() {
        this.departments = this.$store.getters.departments.map(department => {
          return {
            id: department.id,
            text: department.name
          }
        })
    },
    computed: {
      employees() {
        return this.$store.getters.employees
      }
    }
  }
</script>
